import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Form as FinalForm } from 'react-final-form';

import { PASSWORD_RESET_ERRORS } from 'shared/engage/api-error-messages-V2';
import history from '../../common/history';

import { HOME } from '../../common/constants/RouteConstants';
import { TextInputField } from '../../common/components/form-elements';

function ResetPassword(props) {
  const { Store } = props;
  const [activationCodeExpired, setActivationCodeExpired] = useState(false);
  const [tooManyAttempts, setTooManyAttempts] = useState(false);
  const showResendButton = activationCodeExpired || tooManyAttempts;

  async function onSubmit(values) {
    const { email, password, passwordRepeated, resetCode } = values;

    try {
      const result = await Store.resetPassword(email, password, passwordRepeated, resetCode);

      if (result === 0) {
        history.push(`/${HOME}`);
      } else if (result === PASSWORD_RESET_ERRORS.TOO_MANY_ATTEMPTS.errorCode) {
        setTooManyAttempts(true);
        setActivationCodeExpired(false);
      } else if (result === PASSWORD_RESET_ERRORS.CODE_EXPIRED.errorCode) {
        setActivationCodeExpired(true);
        setTooManyAttempts(false);
      }
    } catch (err) {
      // console.log(err)
    }
  }

  async function resendCodeHandler(event, email) {
    event.preventDefault();
    try {
      await Store.requestResetPassword(email);
      setActivationCodeExpired(false);
      setTooManyAttempts(false);
    } catch (err) {
      // console.log(err)
    }
  }

  return (
    <React.Fragment>
      <h2 className='c-login__title'>Set your password</h2>
      <p className='c-login__description'>
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        Please enter a new password. Password's should be at least 8 character long, be a mix of upper and lower case
        letters and contain at least one number and one symbol (!@?;:)
      </p>
      <FinalForm
        onSubmit={onSubmit}
        render={({ values, handleSubmit }) => {
          return (
            <form>
              <TextInputField
                id='email'
                fieldName='email'
                classModifier='mb-3'
                icon='envelope'
                placeholder='Enter email'
                label='Your Email'
                isRequired={true}
              />
              <TextInputField
                id='resetCode'
                fieldName='resetCode'
                icon='pen-alt'
                placeholder='Password reset code from email'
                label='Password reset code'
                isRequired={true}
              />
              <TextInputField
                id='password'
                fieldName='password'
                icon='lock'
                placeholder='New password'
                customType='password'
                label='New Password'
                isRequired={true}
              />
              <TextInputField
                id='passwordRepeated'
                fieldName='passwordRepeated'
                icon='lock'
                placeholder='Repeat password'
                customType='password'
                label='Repeat password'
                isRequired={true}
              />

              <div className='c-field c-field--action l-form__item'>
                <div className='c-field__group'>
                  <button className='o-button o-button--primary' type='submit' onClick={handleSubmit}>
                    <span className='o-label'>Set new password</span>
                  </button>
                  {showResendButton && (
                    <button
                      className='o-button o-button--alternate'
                      onClick={(event) => resendCodeHandler(event, values.email)}
                    >
                      <span className='o-label'>Resend password reset code</span>
                    </button>
                  )}
                </div>
              </div>
            </form>
          );
        }}
      />
      {activationCodeExpired && (
        <div className='c-message is-warning-strong'>
          <h3 className='c-message__title'>Password Reset Code Expired</h3>
          <p className='c-message__description'>
            It appears that your Password reset code has expired. Password reset code is valid for 24 hours.
            <br /> You can request a new Password reset code by clicking on &quot;Resend Password reset code&quot;
            button above.
            <br />
            The new code will be delivered to your email address.
          </p>
        </div>
      )}
      {tooManyAttempts && (
        <div className='c-message is-warning-strong'>
          <h3 className='c-message__title'>Too Many Attempts</h3>
          <p className='c-message__description'>
            You have exceeded the maximum number of password reset attempts and your &quot;Password reset code&quot; has
            been invalidated.
            <br /> You can request a new Password reset code by clicking on &quot;Resend Password reset code&quot;
            button above.
            <br />
            The new code will be delivered to your email address.
          </p>
        </div>
      )}
    </React.Fragment>
  );
}

export default inject((root) => ({ Store: root.RootStore.authStore }))(observer(ResetPassword));
